import React from "react";

import { AHButton, AHText, Box, Circle } from "arkh";
import { FormattedMessage, useIntl } from "react-intl";

import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useSizeClass } from "../../common/Utils/useSizeClass";
import { SizeClass } from "@/src/common/Utils/SizeClass";

import { graphql, useMutation } from "react-relay";
import {
  StoreAdminNavigationProp,
  StoreAdminRouteProps,
} from "../StoreAdmin/StoreAdminNavigation";
import { FormattedDateRaw } from "../../common/dates/useFormattedDateRaw";
import { IntegrationFlyerScreenDeleteFlyerMutation } from "./__generated__/IntegrationFlyerScreenDeleteFlyerMutation.graphql";
import { IntegrationFlyerScreenDeletePollFileMutation } from "./__generated__/IntegrationFlyerScreenDeletePollFileMutation.graphql";

export function IntegrationFlyerScreen(props: {
  navigation: StoreAdminNavigationProp<"IntegrationFlyer">;
  route: StoreAdminRouteProps<"IntegrationFlyer">;
}) {
  const isCompact = useSizeClass().width === SizeClass.COMPACT;
  const insets = useSafeAreaInsets();
  const { title, lastError, lastCheckedAt, status, id, type } =
    props.route.params;
  const [deleteFlyer, flyerLoading] =
    useMutation<IntegrationFlyerScreenDeleteFlyerMutation>(graphql`
      mutation IntegrationFlyerScreenDeleteFlyerMutation($id: ID!) {
        store {
          deleteIntegrationFlyer(id: $id)
        }
      }
    `);
  const [deletePollFile, pollFileLoading] =
    useMutation<IntegrationFlyerScreenDeletePollFileMutation>(graphql`
      mutation IntegrationFlyerScreenDeletePollFileMutation($id: ID!) {
        store {
          deleteIntegrationPollFile(id: $id)
        }
      }
    `);
  const onDelete = () => {
    (type === "pollFile" ? deletePollFile : deleteFlyer)({
      variables: {
        id,
      },
      onCompleted: () => {
        props.navigation.goBack();
      },
    });
  };
  const intl = useIntl();
  const deleteIntegrationTitle = intl.formatMessage({
    defaultMessage: "Delete Integration",
    description: "IntegrationEmaginFlyerScreen delete button",
  });
  return (
    <Box
      spaceVertical="xxlarge"
      spaceHorizontal="large"
      style={{ flex: 1, justifyContent: "space-between" }}
      insets={{ bottom: isCompact ? insets.bottom : 0 }}
    >
      <Box style={{ alignItems: "center" }}>
        <Circle
          size="medium"
          color={
            status === "pending"
              ? "washedText"
              : status === "success"
                ? "positive"
                : "negative"
          }
        />
        <AHText type="title" spaceTop="small" style={{ textAlign: "center" }}>
          {title}
        </AHText>
        {lastError ? (
          <AHText>
            <FormattedMessage
              defaultMessage="Failing"
              description="IntegrationEmaginFlyerScreen failing"
            />
            : {lastError}
          </AHText>
        ) : (
          <AHText>
            <FormattedMessage
              defaultMessage="last checked at {time}"
              description="IntegrationEmaginFlyerScreen LastCheckedAt"
              values={{
                time: lastCheckedAt ? (
                  <FormattedDateRaw dateISO={lastCheckedAt} style="DEFAULT" />
                ) : (
                  ""
                ),
              }}
            />
          </AHText>
        )}
      </Box>
      <AHButton
        style={{ alignSelf: "center" }}
        themeType="negative"
        onPress={onDelete}
        title={deleteIntegrationTitle}
        loading={flyerLoading || pollFileLoading}
      />
    </Box>
  );
}
